module.exports = __webpack_public_path__ + "img/icon_prompt.1b611de8.png";